import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoradaprovarprefatura(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoradaprovarprefatura/FIND_RADAPROVARPREFATURA':
      case '@operacaoradaprovarprefatura/UPDATE_RADAPROVARPREFATURA':
      case '@operacaoradaprovarprefatura/DELETE_RADAPROVARPREFATURA':
      case '@operacaoradaprovarprefatura/STORE_RADAPROVARPREFATURA':
      case '@operacaoradaprovarprefatura/RADAPROVARPREFATURA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoradaprovarprefatura/SUCCESS_REMOVE':
      case '@operacaoradaprovarprefatura/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoradaprovarprefatura/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoradaprovarprefatura;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoradaprovarprefatura/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoradaprovarprefatura;
        break;
      }

      case '@operacaoradaprovarprefatura/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
